import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from 'notistack';

// Import context providers
import { AuthProvider } from './context/AuthContext';

// Import components
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import MainLayout from './components/MainLayout';

// Import pages
import HomePage from './pages/HomePage';
import PostDetail from './pages/PostDetail';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PostList from './pages/PostList';
import PostCreate from './pages/PostCreate';
import PostEdit from './pages/PostEdit';
import Settings from './pages/Settings';
import Resources from './pages/Resources';
import ResourceManager from './pages/ResourceManager';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';

function App() {
  return (
    <>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={3000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <AuthProvider>
          <Routes>
            {/* All routes wrapped in MainLayout to include footer */}
            <Route element={<MainLayout />}>
              {/* Public routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/blog/:id" element={<PostDetail />} />
              <Route path="/secure-portal-access" element={<Login />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />

              {/* Protected admin routes */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="posts" element={<PostList />} />
                <Route path="posts/create" element={<PostCreate />} />
                <Route path="posts/:id" element={<PostEdit />} />
                <Route path="resources" element={<ResourceManager />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </SnackbarProvider>
    </>
  );
}

export default App;
